'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoRss = function GoRss(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 25c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5z m0-10s-2.5 0.1-2.5 2.5 2.5 2.5 2.5 2.5c5.5 0 10 4.5 10 10 0 0 0 2.5 2.5 2.5s2.5-2.5 2.5-2.5c0-8.3-6.7-15-15-15z m0-10s-2.5 0-2.5 2.5 2.5 2.5 2.5 2.5c11 0 20 9 20 20 0 0 0 2.5 2.5 2.5s2.5-2.5 2.5-2.5c0-13.8-11.2-25-25-25z' })
        )
    );
};

exports.default = GoRss;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/rss.js
// module id = 2251
// module chunks = 168707334958949